goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Filter$default");
shadow.js.shim.module$$carbon$icons_react$es$Filter$default = shadow.js.require(363, {}).default;
